import { Link } from 'react-router'

import { EMPTY_STRING } from '../../constants/common'
import { useAppAvailable } from '../../hooks'
import { getPath, isNativeLink } from '../../utils/link'

function CustomLink({
  children,
  className,
  suffix = EMPTY_STRING,
  to,
  ...linkProps
}) {
  const appAvailable = useAppAvailable()

  return (
    <Link
      {...linkProps}
      className={className}
      reloadDocument={isNativeLink(to, appAvailable)}
      to={`${getPath(to, appAvailable)}${suffix}`}
    >
      {children}
    </Link>
  )
}

export default CustomLink
